import { jsxs as h, jsx as e } from "@emotion/react/jsx-runtime";
import { useRef as a, useEffect as p } from "react";
import { ProductIconsAppV2Enum as _ } from "@partoohub/iconography";
import { useClickOutside as w } from "../../../../hooks/useClickOutside.js";
import { ShowMoreContainer as C, ShowMoreButtonContainer as E, ShowMoreMenuContainer as S } from "./ShowMore.styled.js";
import { DEFAULT_MAX_HEIGHT_SHOW_MORE_MENU as R } from "../../helpers.js";
import { useSidebarContext as x } from "../../SidebarContext.js";
import { DynamicMenuRenderer as O } from "../DynamicMenuRenderer/DynamicMenuRenderer.js";
import { ShowMoreButton as k } from "../ShowMoreButton/ShowMoreButton.js";
import { MENU_SHOW_MORE_BUTTON as H } from "../ShowMoreButton/ShowMoreButton.types.js";
const P = ({
  moreText: f,
  showMoreRoutes: t,
  maxHeightShowMoreMenu: M = R
}) => {
  const n = a(null), s = a(null), {
    sidebarRef: l,
    extended: c,
    setExtended: i,
    showMoreMenu: m,
    setShowMoreMenu: o
  } = x(), d = () => {
    m ? r() : (o(!0), i(!0));
  }, r = () => {
    o(!1), i(!1);
  };
  return w({
    refs: [l, n, s],
    onClickOutside: r
  }), p(() => () => {
    o(!1);
  }, []), /* @__PURE__ */ h(C, { as: "li", children: [
    /* @__PURE__ */ e(E, { ref: n, onClick: d, children: /* @__PURE__ */ e(k, { route: {
      dataTrackId: "nav_item_show_more",
      dataPartooRobot: "show_more",
      type: H,
      name: f,
      icon: _.More,
      subRoutes: t
    } }) }),
    m && /* @__PURE__ */ e(S, { extended: c, ref: s, maxHeight: M, children: t.map((u) => /* @__PURE__ */ e(O, { route: u, handleCloseMenu: r }, u.name)) })
  ] });
};
export {
  P as ShowMore
};
